import {FieldPath, FieldValues} from 'react-hook-form';
import {ComponentWithoutChildren} from '../react/types';
import {
  AllowedTextFieldProps,
  BaseControlledTextInputFieldAdapterProps,
  ControlledTextInputFieldAdapter,
} from './ControlledTextInputFieldAdapter';

export type TextInputFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = AllowedTextFieldProps & BaseControlledTextInputFieldAdapterProps<TFieldValues, TName>;

export const TextInputField: ComponentWithoutChildren<TextInputFieldProps> = ({
  defaultValue = '',
  ...props
}: TextInputFieldProps) => {
  return <ControlledTextInputFieldAdapter {...props} defaultValue={defaultValue} />;
};
